import { usePageHeader } from "@hooks/use_page_header";
import { useLocation } from "react-router-dom";
import moment from "moment";

export const MadingDetailPage = () => {
  const { state } = useLocation();
  usePageHeader("Informasi Terkini", { bottomNavigation: "hidden" });


  return (
    <div className="tw-px-4 tw-pt-2 tw-pb-10">
      <div className="tw-p-4 card-body">
        <div className="tw-text-base tw-font-bold tw-mb-2">
          <div className="tw-block tw-text-xs tw-font-light tw-text-text-secondary">
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>
        </div>
        <img
          className="tw-w-full tw-h-full tw-rounded-xl tw-object-cover"
          src={`${state.gambar}`}
          alt=""
        />
        <div className="tw-my-4 tw-text-base tw-text-text-primary tw-font-semibold">
          {state.judul}
        </div>
        <pre
          className="tw-mb-6 tw-text-sm tw-font-medium tw-text-text-primary"
          style={{
            whiteSpace: "pre-wrap",
            wordWrap: "break-word",
            overflow: "auto",
            letterSpacing: "1.3px",
          }}
        >
          {state.pesan}
        </pre>
      </div>
    </div>
  );
};
